import { Box, Typography } from "@mui/material";
import React from "react";
import { LoginHeader } from "../../../components/Header";
import Logo from "../../../assets/images/logo.png";
import useStyles from "./styles";

// Two-pane auth layout: dark brand pane (logo plate + heading) beside the
// form. Replaces LoginWrapper's full-bleed photo background.
function SplitAuthWrapper({ heading, subheading, children }) {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <LoginHeader />
      <Box component="main" className={classes.main}>
        <Box className={classes.card}>
          <Box className={classes.brand}>
            <Box className={classes.stage} aria-hidden="true">
              <span className={`${classes.ring} ${classes.ringOrbit}`} />
              <span className={`${classes.ring} ${classes.ringDashed}`} />
              <span className={`${classes.ring} ${classes.ringPulse}`} />
              <Box className={classes.plate}>
                <img src={Logo} alt="" />
              </Box>
            </Box>
            <Box className={classes.copy}>
              <Typography component="h1" className={classes.heading}>
                {heading}
              </Typography>
              {subheading && (
                <Typography component="p" className={classes.subheading}>
                  {subheading}
                </Typography>
              )}
            </Box>
          </Box>
          <Box className={classes.pane}>{children}</Box>
        </Box>
      </Box>
    </Box>
  );
}

export default React.memo(SplitAuthWrapper);
